<template>
  <div id="cart-address">
    <Spinner v-if="isLoading" />
    <OrderError
      v-if="hasErrors"
      :error="getCurrentErrorMessage"
      :descr="getCurrentErrorDescr"
      :level="getCurrentErrorLevel"
      @onButtonClicked="createNewOrder"
    />
    <article v-else>
      <Header :showFilter="false" />
      <article class="bo-cart-address-body">
         <p>
          ¿Cómo te llamás?
          <input
            class="name-input"
            type="text"
            v-model="name"
            placeholder="Tu nombre acá"
          />
        </p>
        <p>
          ¿A qué dirección lo entregamos?
          <textarea
            class="address-input"
            v-model="address"
            :disabled="isPickup"
            placeholder="Ingresa tu dirección aquí"
          />
        </p>
        <div>
          ¿Preferís pasarlo a buscar por el local?
          <md-switch v-model="isPickup" class="md-primary"
            >Lo paso a buscar!</md-switch
          >
        </div>
        <p>
          ¿Querés aclararnos algo de tu pedido?
          <textarea
            class="notes-input"
            v-model="notes"
            placeholder="Podes escribir lo que quieras sobre como querés tu pedido"
          />
        </p>
      </article>
      <FooterCheckout
        @onConfirmingOrder="onConfirmingOrder"
        @onOrderConfirmFailure="onOrderConfirmFailure"
        @onOrderConfirmSuccess="onOrderConfirmSuccess"
      />
    </article>
  </div>
</template>
<script>
import Header from "../Components/Header";
import OrderError from "../Components/OrderError";
import FooterCheckout from "../Components/FooterCheckout";
import Spinner from "../Components/Spinner";
import cart_mixin from "../mixins/Cart_Mixin";
import mobile_detection from "../mixins/mobile_detection";
import spinner_mixin from "../mixins/Spinner_Mixin";
import order_error_mixin from "../mixins/OrderError_Mixin";

export default {
  mixins: [spinner_mixin, order_error_mixin, cart_mixin, mobile_detection],
  name: "cart_address",
  data() {
    return {
      isPickup: false,
      address: null,
      notes: null,
      name: null
    };
  },
  watch: {
    address() {
      this.$store.commit("SET_ORDER_ADDRESS", this.address);
    },
    isPickup() {

      this.$store.commit("SET_ORDER_IS_PICKUP", this.isPickup);
    },
    notes() {
      this.$store.commit("SET_ORDER_NOTES", this.notes);
    },
    name() {
      this.$store.commit("SET_ORDER_CUSTOMER_NAME", this.name);
    }
  },
  mounted() {
    this.$store.commit("SET_IS_LOADING", false);
    this.$store.commit("SET_CURRENT_ERROR_MESSAGE", null);
    this.$store.commit("SET_CURRENT_ERROR_LEVEL", "success");
    this.$store.commit("SET_CURRENT_ERROR_DESCR", null);
    this.processCart();
  },
  methods: {
    onConfirmingOrder() {
      this.$store.commit("SET_CURRENT_ERROR_MESSAGE", null);
      this.$store.commit("SET_CURRENT_ERROR_LEVEL", "success");
      this.$store.commit("SET_CURRENT_ERROR_DESCR", null);
      this.$store.commit("SET_IS_LOADING", true);
    },
    onOrderConfirmFailure(message) {
      this.$store.commit(
        "SET_CURRENT_ERROR_MESSAGE",
        "No pudimos confirmar tu pedido :("
      );
      this.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
      this.$store.commit("SET_CURRENT_ERROR_DESCR", message);
      this.$store.commit("SET_IS_LOADING", false);
    },
    onOrderConfirmSuccess(response) {
      console.log("Pedido confirmado OK!");
      this.$router.push("ConfirmOrder");
    }
  },
  computed: {},
  components: {
    OrderError,
    Spinner,
    Header,
    FooterCheckout
  }
};
</script>
<style scoped>
.bo-cart-address-body {
  margin-top: 10vh;
  padding-left: 10vw;
  padding-right: 10vw;
  text-align: left;
}
.address-input {
  resize: none;
  min-height: 10vh;
  width: 100%;
}
.notes-input {
  resize: none;
  min-height: 20vh;
  width: 100%;
}
.name-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/CartAddress.vue